export const regEx = {
    reg: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    passwordReg: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
};

export const emailValidation = (email) => {
    return regEx.reg.test(email);
};

export const nameValidation = (name) => {
    return name.length >= 2;
};

export const passwordValidation = (password) => {
    return regEx.passwordReg.test(password);
};
